import { Row } from '~/commonComponents';
import { InviteButton } from '../InviteButton';
import { IProfessionalCardUser } from '../../interfaces';

interface IProfessionalCardActionsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardActionsNew = ({ user }: IProfessionalCardActionsProps) => (
  <Row marginLeft={24} marginRight={30} justifyContent="center" alignItems="center">
    <InviteButton
      user={{
        id: user?.id,
        image: user?.profileImage,
        name: user?.fullname,
        profession: user?.professions?.join(','),
        professions: user?.professions,
        isFavorite: true,
      }}
      disabled={!user?.isAvailable}
      source="favorites"
    />
  </Row>
);
